import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import "../../styling/sidebar.css";
import "../../styling/expensepop.css";
import GetUser from "../../services/get-user";
import aws from "aws-sdk";
import { toast } from "react-toastify";

export default function EIPopup(props) {
  const [name, setName] = useState(props.keydata.name);
  const [expenseID, setexpenseID] = useState(props.keydata._id);
  const [imgkey, setImgkey] = useState(props.keydata.receiptImg);
  const [disable,setDisable]=useState(false);
  const [imgurl, setImgurl] = useState("");
  const [imgsrc,setImgSrc]=useState("");
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    if (imgkey) {
      setImgSrc("https://sotira-back-test.herokuapp.com/" + imgkey);  
      axios
        .get("https://sotira-back-test.herokuapp.com/image/image/" + imgkey, {
          params: GetUser(),
        })
        .then((response) => {
          setImgurl(response.data.url);
        }).catch((error)=>{console.log("error",error);
        });
    }  
  },[imgkey,imgsrc])
  
  const userID = GetUser();
  const bucketName = "sotira-expenses-receipts-test";
  const region = "us-west-1";
  const accessKeyId = "AKIA5NU6SDDXI5HUA7PT";
  const secretAccessKey = "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";

  const s3 = new aws.S3({
    region,
    accessKeyId,
    secretAccessKey,
  });

  var myBucket = new aws.S3({
    params: { Bucket: bucketName },
    region: region,
  });

  const uploadFile = (file) => {
    const MAX_FILE_SIZE = 1024 * 1025 * 5;
    if (file.size > MAX_FILE_SIZE) {
      alert("File too large > 5MB");
      return;
    }
    const date = new Date();
    const fileKey = String(date.getTime()) + file.name;
    const fileKeyTotal = String(userID.userID) + "/" + fileKey;
    const params = {
      Key: fileKeyTotal,
      Bucket: bucketName,
      Body: file,
    };
    var putObjectPromise = s3.putObject(params).promise();
    putObjectPromise
      .then(function (data) {
        console.log(
          "Successfully uploaded data to " + params.Bucket + "/" + params.Key
        );
      })
      .catch((error) => console.log("error==", error));
    return axios
      .post("https://sotira-back-test.herokuapp.com/image/add_image_key", {
        userID: user.userID,
        expenseID: expenseID,
        key: fileKey,
      })
      .then((response) => {
        sessionStorage.setItem("option", "expense");
        setLoading(false);
        props.closeImageModel(false);
        props.setReloadTableData((prevState) => !prevState);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const [selectedFile, setSelectedFile] = useState<File>();

  const history = useHistory();
  const location = useLocation();
  const user = GetUser();

  const handleFileSelect = (event) => {
    var MAX_FILE_SIZE = 5 * 1024 * 1024;
    const fileSize = event.target.files[0];
    if(fileSize.size > MAX_FILE_SIZE)
    {
       toast.error("please uplaod image within 5 mb!!")  
       setDisable(true)     
    }
    else
    {
        setDisable(false)
    }
    setSelectedFile(event.target.files[0]);
    if (props.isUpdateImage) {
      if (event.target.files && event.target.files[0]) {
        setImgurl(URL.createObjectURL(event.target.files[0]));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    if (selectedFile) {
      formData.append("file", selectedFile);
      console.log(selectedFile);
      try {
        uploadFile(selectedFile);
      } catch (e: any) {
        alert(e.message);
      }
    }
    else{
      setDisable(true);
      toast.error("please choose file!!");
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="name" className="form-group required">
        <Form.Label className="control-label"> Name </Form.Label>
        <Form.Control autoFocus type="name" value={name} readOnly />
      </Form.Group>
      {props.isUpdateImage && (
        <Form.Group controlId="formFile" className={imgsrc ? "mb-4" : "mb-2"}>
          <Form.Label> Upload image file </Form.Label>
          <Form.Control
            type="file"
            accept=".png,.jpg,.jpeg,.gif"
            onChange={handleFileSelect}
            id="fileInput"
          />
        </Form.Group>
      )}
      {imgsrc ? (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <img className="img-container mb-3" src={imgurl}></img>
        </div>
      ) : (
        <>
          {!props.isUpdateImage && (
            <>
              <Form.Group controlId="formFile" className="mb-3">
                <Form.Label> Upload image file </Form.Label>
                <Form.Control
                  type="file"
                  accept=".png,.jpg,.jpeg,.gif"
                  onChange={handleFileSelect}
                />
              </Form.Group>

              <Button
                block
                size="sm"
                type="submit"
                disabled={disable}
              >
                {loading ? (
                  <>
                    <CircularProgress className="file-loader mr-3" />
                    Add Image
                  </>
                ) : (
                  "Add Image"
                )}
              </Button>
            </>
          )}
        </>
      )}
      {props.isUpdateImage && (
        <Button
          block
          size="sm"
          type="submit"
          disabled={disable}
        >
          {loading ? (
            <>
              <CircularProgress className="file-loader mr-3" />
              Updating
            </>
          ) : (
            "Update Image"
          )}
        </Button>
      )}
    </Form>
  );
}
